// extracted by mini-css-extract-plugin
module.exports = {"add":"StakingInput_add__NBotE","input":"StakingInput_input__A1qPp"};